export const deepCopy = (obj: object) => JSON.parse(JSON.stringify(obj));
